<template>
  <div class="inspection-main">
    <div class="inspection-wrap">
      <header class="header">
        <div class="logo">
          <img src="https://renhe-platform-pre.oss-cn-shanghai.aliyuncs.com/2025-04-28/1745819464041_header-title-bj.png" />
        </div>
      </header>

      <infoBar @gotoPage="gotoPage" :inspectionData="props.inspectionData" />

      <div class="content">
        <mainForm :inspectionData="props.inspectionData" />
      </div>
    </div>
  </div>
</template>

<script setup>
import infoBar from "../cmp/infoBar.vue";
import mainForm from "../cmp/mainForm/index.vue";

const props = defineProps({
  inspectionData: {
    required: true,
    type: Object,
  },
});

const emits = defineEmits(["gotoPage"]);

const gotoPage = (page) => {
  emits("gotoPage", page);
};
</script>

<style scoped lang="scss">
.inspection-main {
  background-color: #fbf8ef;
  display: flex;
  flex-direction: column;
  height: 100%;

  .inspection-wrap {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;

    .header {
      flex: 0 0 auto;
      overflow: hidden;
      border-top: 10px solid #ab812d;
      height: 100px;
      background: #ffffff url(https://renhe-platform-pre.oss-cn-shanghai.aliyuncs.com/2025-04-28/1745818808900_bj.png) no-repeat right top;
      border-bottom: 1px solid #e0dddd;

      .logo {
        width: 1200px;
        margin: 0 auto;
        height: 100%;
        display: flex;
        align-items: center;
      }
    }

    .content {
      height: 100%;
      overflow: hidden;
      margin: 20px auto;
    }
  }
}
</style>
